import { createContext, useCallback, useEffect, useRef, useState } from 'react';
import axios from 'axios';

import { LangEn } from 'assets/locales/en';
import { Language as LanguageManager } from 'assets/locales/fLang';
import { LangFr } from 'assets/locales/fr';
import { useLocation } from 'react-router-dom';
import { toast } from 'react-toastify';
import { validateAndCleanXsrfToken } from 'utils/tokenUtils';
import ApiDatabase, { dispatchSessionExpired } from '../server';

const roadContext = createContext({});

function ContextProvider({ children }) {
  // *******   Section Sidebar   *******
  const storedSidebarExpanded = localStorage.getItem('sidebar-expanded');
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [sidebarExpanded, setSidebarExpanded] = useState(
    storedSidebarExpanded === null ? false : storedSidebarExpanded === 'true'
  );
  // *******   Section Refresh   *******
  const [refreshUser, setRefreshUser] = useState(false);
  const refreshLoadUser = () => {
    setRefreshUser(!refreshUser);
  };
  const [refreshWorker, setRefreshWorker] = useState(false);
  const refreshLoadWorker = () => {
    setRefreshWorker(!refreshWorker);
  };
  // *******   Section Language   *******
  //    instancie le manager
  const language = new LanguageManager();
  //    charge les fichiers de langues (ils seront chargés qu'une fois)
  language.loadLanguage(LangFr);
  language.loadLanguage(LangEn);
  //    spécifie la langue en cours
  language.setLanguage('fr');

  // *******   Section Modal   *******
  const [modalShow, setModalShow] = useState(false);
  const [modalType, setModalType] = useState('');
  const [modalData, setModalData] = useState({});
  const [modalDataReturn, setModalDataReturn] = useState({});

  // *******   Section URL   *******
  const [slideOverShow, setSlideOverShow] = useState(false);
  const [slideOverType, setSlideOverType] = useState('');
  const [slideOverHasUnsavedChanges, setSlideOverHasUnsavedChanges] =
    useState(false);
  const [missionInitialPage, setMissionInitialPage] = useState(undefined);

  // *******   Section SlideOver Navigation   *******
  const [slideOverCandidatesList, setSlideOverCandidatesList] = useState([]);
  const [slideOverCurrentIndex, setSlideOverCurrentIndex] = useState(0);
  const [slideOverMissionActions, setSlideOverMissionActions] = useState(null);

  // *******   Section URL   *******
  const route = useLocation();
  const { pathname } = route;
  //1 - interimaire 2- entreprise
  const [typeNav, setTypeNav] = useState(1);
  const [email, setEmail] = useState('');
  const [name, setName] = useState({
    firstname: '',
    lastname: '',
  });
  useEffect(() => {
    if (pathname.includes('entreprise')) setTypeNav(2);
    else setTypeNav(1);
  }, [pathname]);

  const [auth, setAuth] = useState({});
  const updateUser = (pToken = '-1', pRole) => {
    if (pToken !== '-1') {
      localStorage.setItem('xsrfToken', pToken);
      localStorage.setItem('rUser', pRole);
    }
  };

  // *******   Section Time Sheets   *******
  const [timeData, setTimeData] = useState({
    id: '',
    id_time_sheet: '',
    index: '',
    day_hours_ent: '',
    periode_one_start: '',
    periode_one_end: '',
    periode_two_start: '',
    periode_two_end: '',
    periode_three_start: '',
    periode_three_end: '',
  });
  const [totalH, setTotalH] = useState(0);
  const [refreshTime, setRefreshTime] = useState(false);
  const [timeCheck, setTimeCheck] = useState({});
  const [content, setContent] = useState('');
  // *******   Section OBJ   *******
  const [expID, setExpID] = useState('');
  const [objID, setObjID] = useState('');
  // Time sheet whose history the slide over shows. Kept apart from objID,
  // which already carries other selections.
  const [timeSheetHistoryId, setTimeSheetHistoryId] = useState(null);
  const [objType, setObjType] = useState('');
  const [adminTempWorkerId, setAdminTempWorkerId] = useState('');
  const [adminUserId, setAdminUserId] = useState('');
  const [adminFileName, setAdminFileName] = useState('');
  const [adminType, setAdminType] = useState('');
  const [updateTempWorker, setUpdateTempWorker] = useState(false);

  const [coeffs, setCoeffs] = useState([]);

  // #region **** Vivier ****
  const [infoVivier, setInfoVivier] = useState();
  const [listVivier, setListVivier] = useState();
  const [refreshVivierLog, setRefreshVivierLog] = useState(true);
  // #endregion **** Vivier ****

  const [userUnAssigned, setUserUnAssigned] = useState({});

  const [currentPageTimeSheetToBeChecked, setCurrentPageTimeSheetToBeChecked] =
    useState(1);
  const [
    timeSheetSearchTimeSheetToBeChecked,
    setTimeSheetSearchTimeSheetToBeChecked,
  ] = useState('');
  const [
    timeSheetSearchTypeTimeSheetToBeChecked,
    setTimeSheetSearchTypeTimeSheetToBeChecked,
  ] = useState('');
  const [dateRangeTimeSheetToBeChecked, setDateRangeTimeSheetToBeChecked] =
    useState([null, null]);

  const [currentPageTimeSheetChecked, setCurrentPageTimeSheetChecked] =
    useState(1);
  const [timeSheetSearchTimeSheetChecked, setTimeSheetSearchTimeSheetChecked] =
    useState('');
  const [
    timeSheetSearchTypeTimeSheetChecked,
    setTimeSheetSearchTypeTimeSheetChecked,
  ] = useState('');
  const [dateRangeTimeSheetChecked, setDateRangeTimeSheetChecked] = useState([
    null,
    null,
  ]);

  const [currentPageTimeSheetLitigation, setCurrentPageTimeSheetLitigation] =
    useState(1);
  const [
    timeSheetSearchTimeSheetLitigation,
    setTimeSheetSearchTimeSheetLitigation,
  ] = useState('');
  const [
    timeSheetSearchTypeTimeSheetLitigation,
    setTimeSheetSearchTypeTimeSheetLitigation,
  ] = useState('');
  const [dateRangeTimeSheetLitigation, setDateRangeTimeSheetLitigation] =
    useState([null, null]);

  const [openModal, setOpenModal] = useState(false);

  const [missionDetails, setMissionDetails] = useState({});
  const [scheduleWeeks, setScheduleWeeks] = useState([]);
  const [updSchedule, setUpdSchedule] = useState(false);
  const [activeScheduleWeekDay, setActiveScheduleWeekDay] = useState([]);
  const [scheduleWeeksNew, setScheduleWeeksNew] = useState([]);
  const [refreshMissionDetails, setRefreshMissionDetails] = useState({});

  const [refreshCompanyBigAccount, setRefreshCompanyBigAccount] =
    useState(false);

  const [reviewUntreatedDelete, setReviewUntreatedDelete] = useState(false);
  const [refreshUntreated, setRefreshUntreated] = useState(false);

  const [refreshQualifications, setRefreshQualifications] = useState(false);
  const [refreshQualification, setRefreshQualification] = useState(false);

  const [usersVivier, setUsersVivier] = useState([]);

  const [userVivierToArchive, setUserVivierToArchive] = useState({});
  const [userVivierToArchiveUpdated, setUserVivierToArchiveUpdated] = useState(
    {}
  );

  const [commentID, setCommentID] = useState('');
  const [commentIDUpd, setCommentIDUpd] = useState('');

  // *******   Section Mission Refuse Candidat   *******
  const [tempWorkerToRefuse, setTempWorkerToRefuse] = useState(null);
  const [refuseMissionId, setRefuseMissionId] = useState(null);
  const [currentRefusedReason, setCurrentRefusedReason] = useState(null);
  const [currentRefusedReasonComment, setCurrentRefusedReasonComment] = useState('');

  const [userData, setUserData] = useState({});
  const [tempWorkerData, setTempWorkerData] = useState({});

  const [target, setTarget] = useState('');

  const [assignationMissionTempWorker, setAssignationMissionTempWorker] =
    useState({});

  const [modifyMissionDetailData, setModifyMissionDetailData] = useState({});

  const [listChangesMissionDetail, setListChangesMissionDetail] = useState({});
  const [
    isChangesNeedsNewContractMissionDetail,
    setIsChangesNeedsNewContractMissionDetail,
  ] = useState({});

  const [searchMissionResult, setSearchMissionResult] = useState([]);

  const [searchTempWorkerResult, setSearchTempWorkerResult] = useState(false);
  const [tempWorkerCommentCountByUserId, setTempWorkerCommentCountByUserId] =
    useState({});

  const [refreshPayslips, setRefreshPayslips] = useState(false);

  const [
    searchTempWorkerAssignationResult,
    setSearchTempWorkerAssignationResult,
  ] = useState(false);
  const [
    searchTempWorkerAssignationRefusedResult,
    setSearchTempWorkerAssignationRefusedResult,
  ] = useState(false);
  const [
    searchTempWorkerAssignationPendingContactResult,
    setSearchTempWorkerAssignationPendingContactResult,
  ] = useState(false);

  const [searchTempWorkerInviteResult, setSearchTempWorkerInviteResult] =
    useState([]);

  const [infoMission, setInfoMission] = useState(false);

  const [updatedTimesheet, setUpdatedTimesheet] = useState({});

  const [dataCreateMission, setDataCreateMission] = useState({
    company: null,
    idLocation: null,
    activity: '',
    qualification: '',
    title: '',
    tools: [],
    licences: [],
    languages: [],
    contact_name: '',
    contact_poste: 'Responsable',
    location: '',
    dateStart: '',
    dateEnd: '',
    schedule: [],
    isScheduleCheck: true,
    isConfirmedSchedule: false,
    isScheduleRequired: false,
    users_invite: [],
    motif: '',
    other: '',
    other_interim: '',
    salary: '',
    inviteType: '',
    vivierStatus: [],
    vivierSelections: [],
    globalNotificationRequested: false,
    user_assigned: {},
    reference: '',
  });

  const infoMissionRef = useRef(infoMission);
  const searchTempWorkerResultRef = useRef(searchTempWorkerResult);

  useEffect(() => {
    infoMissionRef.current = infoMission;
  }, [infoMission]);

  useEffect(() => {
    searchTempWorkerResultRef.current = searchTempWorkerResult;
  }, [searchTempWorkerResult]);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const token = validateAndCleanXsrfToken();
      if (!token) {
        if (localStorage.getItem('rUser')) {
          dispatchSessionExpired();
        } else {
          window.location.href = process.env.REACT_APP_ADMIN_LOGIN;
        }
      }
    }, 1000);

    return () => clearInterval(intervalId);
  }, []);

  const socketRef = useRef(null);

  useEffect(() => {
    const manageSocket = async () => {
      socketRef.current = await ApiDatabase.connectSocketWithToken();
      if (socketRef.current) {
        const isSameMissionId = (missionId, otherId) => {
          const a = missionId?.toString?.() || missionId;
          const b = otherId?.toString?.() || otherId;
          return Boolean(a && b && a === b);
        };

        const matchesSearchMissionEntry = (mission, updatedMission) => {
          const missionRealId =
            mission.id_mission_real?.toString?.() || mission.id_mission_real;
          const updatedRealId =
            updatedMission.id_mission_real?.toString?.() ||
            updatedMission.id_mission_real;
          const missionId = mission._id?.toString?.() || mission._id;
          const updatedId =
            updatedMission._id?.toString?.() || updatedMission._id;

          return (
            (missionRealId &&
              updatedRealId &&
              missionRealId === updatedRealId) ||
            (missionId && updatedId && missionId === updatedId)
          );
        };

        const normalizeListUser = (user) => {
          if (user == null) return null;
          const userId = user.user_id ?? user._id;
          if (!userId) return null;
          return user;
        };

        const resolveListUser = (mission, updatedMission) => {
          if (
            updatedMission.isAssigned === false ||
            updatedMission.assigned === false
          ) {
            return null;
          }
          if (Object.prototype.hasOwnProperty.call(updatedMission, 'user')) {
            return normalizeListUser(updatedMission.user);
          }
          if (Object.prototype.hasOwnProperty.call(updatedMission, 'user_assigned')) {
            return normalizeListUser(updatedMission.user_assigned);
          }
          return normalizeListUser(mission.user);
        };

        const mergeSearchMissionEntry = (mission, updatedMission) => {
          const user = resolveListUser(mission, updatedMission);
          const isAssigned =
            user != null ||
            updatedMission.isAssigned === true ||
            updatedMission.assigned === true;
          const adminEmployeeAssigned =
            'admin_employee_assigned' in updatedMission
              ? updatedMission.admin_employee_assigned ?? null
              : mission.admin_employee_assigned;

          return {
            ...mission,
            ...updatedMission,
            user,
            isAssigned: isAssigned,
            admin_employee_assigned: adminEmployeeAssigned,
            contract_company: isAssigned
              ? (updatedMission.contract_company ?? mission.contract_company)
              : [],
            contract_tempworker: isAssigned
              ? (updatedMission.contract_tempworker ?? mission.contract_tempworker)
              : [],
          };
        };

        const isSameUserId = (leftId, rightId) => {
          const a = leftId?.toString?.() || leftId;
          const b = rightId?.toString?.() || rightId;
          return Boolean(a && b && a === b);
        };

        const CANDIDATE_CATEGORIES = [
          'complete',
          'partial',
          'not_updated',
          'incomplete',
          // Candidates whose landing signup is unfinished: they were never
          // asked for their availability, so grading it would only report a
          // question that was never put to them.
          'signup_pending',
        ];

        const splitPostulateMissionUsers = (usersByCategory = {}) => {
          const refusedUsers = {
            complete: [],
            partial: [],
            not_updated: [],
            incomplete: [],
            signup_pending: [],
          };
          const pendingContactUsers = {
            complete: [],
            partial: [],
            not_updated: [],
            incomplete: [],
            signup_pending: [],
          };
          const otherUsers = {
            complete: [],
            partial: [],
            not_updated: [],
            incomplete: [],
            signup_pending: [],
          };

          CANDIDATE_CATEGORIES.forEach((category) => {
            const users = usersByCategory[category] || [];
            refusedUsers[category] = users.filter((user) => user.refused === true);
            pendingContactUsers[category] = users.filter(
              (user) => user.refused === false && user.pendingContact === true
            );
            otherUsers[category] = users.filter(
              (user) => user.refused === false && user.pendingContact !== true
            );
          });

          return { refusedUsers, pendingContactUsers, otherUsers };
        };

        const patchCategorizedUserLists = (lists, idUser, incomingUsers = {}) => {
          const nextLists = { ...lists };
          CANDIDATE_CATEGORIES.forEach((category) => {
            const current = nextLists[category] || [];
            nextLists[category] = current.filter(
              (user) => !isSameUserId(user.id_user, idUser)
            );
            const userData = (incomingUsers[category] || []).find((user) =>
              isSameUserId(user.id_user, idUser)
            );
            if (userData) {
              nextLists[category] = [...nextLists[category], { ...userData }];
            }
          });
          return nextLists;
        };

        const patchCommentCountInLists = (lists, idUser, commentCount) => {
          if (!lists || typeof lists !== 'object') return lists;
          const nextLists = { ...lists };

          CANDIDATE_CATEGORIES.forEach((category) => {
            const current = nextLists[category] || [];
            nextLists[category] = current.map((user) =>
              isSameUserId(user.id_user, idUser)
                ? { ...user, commentCount }
                : user
            );
          });

          return nextLists;
        };

        const normalizeMissionDetailsAssignment = (details) => {
          if (!details) return details;
          if (!details.user_assigned) {
            return {
              ...details,
              user_assigned: null,
              user_assigned_infos: null,
              contract_company: [],
              contract_tempworker: [],
            };
          }
          return details;
        };

        const buildListUserFromMissionDetails = (details) => {
          if (!details?.user_assigned) return null;
          const assignedId =
            details.user_assigned?._id ?? details.user_assigned;
          if (!assignedId) return null;
          const infos = details.user_assigned_infos || {};
          return {
            user_id: assignedId,
            firstname: infos.firstname,
            lastname: infos.lastname,
            email: infos.email,
            phone: infos.phone,
            id_bestt: infos.id_bestt,
          };
        };

        const patchSearchMissionResultFromDetails = (missionId, details) => {
          setSearchMissionResult((prevData) => {
            if (!Array.isArray(prevData)) return prevData;
            return prevData.map((mission) => {
              if (
                !isSameMissionId(mission.id_mission_real, missionId) &&
                !isSameMissionId(mission._id, missionId)
              ) {
                return mission;
              }
              return {
                ...mission,
                user: buildListUserFromMissionDetails(details),
                isAssigned: Boolean(details.user_assigned),
                contract_company: details.user_assigned
                  ? (details.contract_company ?? mission.contract_company)
                  : [],
                contract_tempworker: details.user_assigned
                  ? (details.contract_tempworker ?? mission.contract_tempworker)
                  : [],
                status: details.status ?? mission.status,
                title: details.title ?? mission.title,
                duration: details.duration ?? mission.duration,
                salary: details.salary ?? mission.salary,
                users: details.users ?? mission.users,
              };
            });
          });
        };

        const handleSearchMissionUpdated = (change, eventName) => {
          const url = 'admin/searchMission';
          const data = {};
          ApiDatabase.updateCacheEntry(url, data, change.searchMission);

          if (change.searchMission?.length > 0) {
            change.searchMission.forEach((updatedMission) => {
              const missionId =
                updatedMission.id_mission_real ?? updatedMission._id;
              ApiDatabase.patchSearchMissionCache(missionId, (mission) =>
                mergeSearchMissionEntry(mission, updatedMission)
              );
            });

            setSearchMissionResult((prevData) => {
              if (!Array.isArray(prevData)) return prevData;
              return prevData.map((mission) => {
                const updatedMission = change.searchMission.find((entry) =>
                  matchesSearchMissionEntry(mission, entry)
                );
                return updatedMission
                  ? mergeSearchMissionEntry(mission, updatedMission)
                  : mission;
              });
            });
          }
        };

        const handleSearchMissionInserted = (change, eventName) => {
          const url = 'admin/searchMission';
          const data = {};
          ApiDatabase.updateCacheEntry(url, data, change.searchMission);

          if (change.searchMission?.length > 0) {
            setSearchMissionResult((prevData) => {
              if (!Array.isArray(prevData)) return prevData;
              const updatedData = [...prevData];

              change.searchMission.forEach((newMission) => {
                const existingMission = updatedData.find((mission) =>
                  matchesSearchMissionEntry(mission, newMission)
                );

                if (existingMission) {
                  const index = updatedData.indexOf(existingMission);
                  updatedData[index] = mergeSearchMissionEntry(
                    existingMission,
                    newMission
                  );
                } else {
                  updatedData.push(mergeSearchMissionEntry({}, newMission));
                }
              });

              return updatedData;
            });
          }
        };

        const handleTempWorkerPostulateMissionUpdated = (change, eventName) => {
          if (
            !change.idMission ||
            !change.tempWorkerPostulateMission ||
            !isSameMissionId(infoMissionRef.current?._id, change.idMission)
          ) {
            return;
          }

          const url = 'admin/getTempWorkerPostulateMission';
          const data = { idMission: change.idMission };
          ApiDatabase.updateCacheEntry(
            url,
            data,
            change.tempWorkerPostulateMission
          );

          const { refusedUsers, pendingContactUsers, otherUsers } =
            splitPostulateMissionUsers(change.tempWorkerPostulateMission);

          setSearchTempWorkerAssignationRefusedResult(refusedUsers);
          setSearchTempWorkerAssignationPendingContactResult(pendingContactUsers);
          setSearchTempWorkerAssignationResult(otherUsers);
        };

        const handleTempWorkerInviteMissionUpdated = (change, eventName) => {
          if (
            change.idMission &&
            change.tempWorkerInviteMission &&
            isSameMissionId(infoMissionRef.current?._id, change.idMission)
          ) {
            const url = 'admin/getTempWorkerInviteMission';
            const data = { idMission: change.idMission };
            ApiDatabase.updateCacheEntry(
              url,
              data,
              change.tempWorkerInviteMission
            );
            setSearchTempWorkerInviteResult(change.tempWorkerInviteMission);
          }
        };

        const handleMissionContractsUpdated = (change) => {
          if (!change?.idMission) return;

          setSearchMissionResult((prevData) => {
            if (!Array.isArray(prevData)) return prevData;
            return prevData.map((mission) => {
              if (
                !isSameMissionId(mission.id_mission_real, change.idMission) &&
                !isSameMissionId(mission._id, change.idMission)
              ) {
                return mission;
              }
              return {
                ...mission,
                contract_company: change.contract_company ?? mission.contract_company,
                contract_tempworker:
                  change.contract_tempworker ?? mission.contract_tempworker,
              };
            });
          });

          if (isSameMissionId(infoMissionRef.current?._id, change.idMission)) {
            setInfoMission((prev) => {
              if (!prev) return prev;
              return {
                ...prev,
                contract_company: change.contract_company ?? prev.contract_company,
                contract_tempworker:
                  change.contract_tempworker ?? prev.contract_tempworker,
              };
            });
          }
        };

        const handleMissionDetailsByIdUpdated = (change, eventName) => {
          if (!change.idMission || !change.missionDetailsById) return;

          const normalizedDetails = normalizeMissionDetailsAssignment(
            change.missionDetailsById
          );

          patchSearchMissionResultFromDetails(
            change.idMission,
            normalizedDetails
          );

          if (isSameMissionId(infoMissionRef.current?._id, change.idMission)) {
            const url = 'admin/getMissionDetailsById';
            const data = { idMission: change.idMission };
            ApiDatabase.updateCacheEntry(url, data, normalizedDetails);
            setInfoMission(normalizedDetails);
          }
        };

        const handleTempWorkerDenormalizedUpdated = (change) => {
          if (!change?.users?.length) return;
          setUsersVivier(change.users);
        };

        const handleTempWorkerDenormalizedDeleted = (change) => {
          if (!change?.idUser) return;
          setUsersVivier([{ id_user: change.idUser, _deleted: true }]);
        };

        const handleSearchTempWorkerMissionUpdated = (change, eventName) => {
          if (
            !change.idMission ||
            !change.idUser ||
            !change.searchTempWorker ||
            !isSameMissionId(infoMissionRef.current?._id, change.idMission)
          ) {
            return;
          }

          const url = 'admin/searchTempWorker';
          const data = { idMission: change.idMission };
          ApiDatabase.updateCacheEntry(url, data, change.searchTempWorker);

          if (
            searchTempWorkerResultRef.current &&
            typeof searchTempWorkerResultRef.current === 'object'
          ) {
            setSearchTempWorkerResult((prevData) => {
              if (!prevData || typeof prevData !== 'object') return prevData;
              return patchCategorizedUserLists(
                prevData,
                change.idUser,
                change.searchTempWorker
              );
            });
          }
        };

        const handleTempWorkerCommentCountUpdated = (change) => {
          if (!change?.idUser || typeof change.commentCount !== 'number') return;

          const idUser = change.idUser.toString();
          setTempWorkerCommentCountByUserId((prev) => ({
            ...prev,
            [idUser]: change.commentCount,
          }));

          setSearchTempWorkerResult((prevData) =>
            patchCommentCountInLists(prevData, change.idUser, change.commentCount)
          );
          setSearchTempWorkerAssignationResult((prevData) =>
            patchCommentCountInLists(prevData, change.idUser, change.commentCount)
          );
          setSearchTempWorkerAssignationRefusedResult((prevData) =>
            patchCommentCountInLists(prevData, change.idUser, change.commentCount)
          );
          setSearchTempWorkerAssignationPendingContactResult((prevData) =>
            patchCommentCountInLists(prevData, change.idUser, change.commentCount)
          );
        };

        const socketHandlers = {
          searchMissionUpdated: handleSearchMissionUpdated,
          searchMissionInserted: handleSearchMissionInserted,
          tempWorkerPostulateMissionUpdated: handleTempWorkerPostulateMissionUpdated,
          tempWorkerInviteMissionUpdated: handleTempWorkerInviteMissionUpdated,
          missionDetailsByIdUpdated: handleMissionDetailsByIdUpdated,
          missionContractsUpdated: handleMissionContractsUpdated,
          searchTempWorkerMissionUpdated: handleSearchTempWorkerMissionUpdated,
          tempWorkerCommentCountUpdated: handleTempWorkerCommentCountUpdated,
          tempWorkerDenormalizedUpdated: handleTempWorkerDenormalizedUpdated,
          tempWorkerDenormalizedDeleted: handleTempWorkerDenormalizedDeleted,
          payslipImportCompleted: (data) => {
            const s = data?.summary;
            toast.success(
              `Import terminé : ${s?.success || 0}/${s?.total || 0} fiche(s) importée(s).`
            );
            setRefreshPayslips((prev) => !prev);
          },
        };

        Object.entries(socketHandlers).forEach(([eventName, handler]) => {
          socketRef.current.on(eventName, handler);
        });
      }
    };

    manageSocket();

    return () => {
      if (socketRef.current) {
        socketRef.current.off('searchMissionUpdated');
        socketRef.current.off('searchMissionInserted');
        socketRef.current.off('tempWorkerPostulateMissionUpdated');
        socketRef.current.off('tempWorkerInviteMissionUpdated');
        socketRef.current.off('missionDetailsByIdUpdated');
        socketRef.current.off('missionContractsUpdated');
        socketRef.current.off('searchTempWorkerMissionUpdated');
        socketRef.current.off('tempWorkerCommentCountUpdated');
        socketRef.current.off('tempWorkerDenormalizedUpdated');
        socketRef.current.off('tempWorkerDenormalizedDeleted');
        socketRef.current.off('payslipImportCompleted');
      }
    };
  }, []);

  const removeAllParameters = () => {
    const params = new URLSearchParams(window.location.search);
    const preserved = new URLSearchParams();
    ['y', 'm'].forEach((key) => {
      if (params.has(key)) preserved.set(key, params.get(key));
    });
    const qs = preserved.toString();
    const url = window.location.origin + window.location.pathname + (qs ? '?' + qs : '');
    window.history.replaceState({}, document.title, url);
  };

  // Fonction helper pour les optimistic updates de refus/annulation de refus
  // Utilisée par le modal et les composants pour mettre à jour l'état immédiatement
  const updateTempWorkerRefusedState = useCallback((idTempWorker, isRefusing, refusedData = {}) => {
    if (isRefusing) {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete', 'signup_pending']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setSearchTempWorkerAssignationPendingContactResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete', 'signup_pending']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              if (!tempWorkerData) {
                tempWorkerData = newData[key][index];
                keyFound = key;
              }
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationRefusedResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const refusedArray = newData[keyFound] || [];
          const newRefusedArray = [
            ...refusedArray,
            {
              ...tempWorkerData,
              refused: true,
              pendingContact: false,
              refusedReason: refusedData.refusedReason || null,
              refusedReasonId: refusedData.refusedReasonId || null,
              refusedReasonComment: refusedData.refusedReasonComment || null,
            },
          ];
          newRefusedArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newRefusedArray };
        });
      }, 0);
    } else {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationRefusedResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete', 'signup_pending']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const assignationArray = newData[keyFound] || [];
          const newAssignationArray = [
            ...assignationArray,
            {
              ...tempWorkerData,
              refused: false,
              pendingContact: false,
              refusedReason: null,
              refusedReasonId: null,
              refusedReasonComment: null,
            },
          ];
          newAssignationArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newAssignationArray };
        });
      }, 0);
    }
  }, []);

  const updateTempWorkerPendingContactState = useCallback((idTempWorker, isPending) => {
    if (isPending) {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete', 'signup_pending']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationPendingContactResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const pendingArray = newData[keyFound] || [];
          const newPendingArray = [
            ...pendingArray,
            { ...tempWorkerData, pendingContact: true },
          ];
          newPendingArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newPendingArray };
        });
      }, 0);
    } else {
      let tempWorkerData = null;
      let keyFound = null;

      setSearchTempWorkerAssignationPendingContactResult((prevData) => {
        if (!prevData) return prevData;
        const newData = { ...prevData };
        for (const key of ['complete', 'partial', 'not_updated', 'incomplete', 'signup_pending']) {
          if (newData[key]) {
            const index = newData[key].findIndex((data) => data.id_user === idTempWorker);
            if (index !== -1) {
              tempWorkerData = newData[key][index];
              keyFound = key;
              newData[key] = [...newData[key]];
              newData[key].splice(index, 1);
              break;
            }
          }
        }
        return newData;
      });

      setTimeout(() => {
        setSearchTempWorkerAssignationResult((prevData) => {
          if (!prevData || !tempWorkerData || !keyFound) return prevData;
          const newData = { ...prevData };
          const assignationArray = newData[keyFound] || [];
          const newAssignationArray = [
            ...assignationArray,
            { ...tempWorkerData, pendingContact: false },
          ];
          newAssignationArray.sort((a, b) => {
            const lastnameA = a.lastname?.toLowerCase() || '';
            const lastnameB = b.lastname?.toLowerCase() || '';
            return lastnameA.localeCompare(lastnameB);
          });
          return { ...newData, [keyFound]: newAssignationArray };
        });
      }, 0);
    }
  }, []);

  // Fonction helper pour les optimistic updates d'attribution de mission
  // Met à jour searchMissionResult et infoMission immédiatement
  const updateMissionAssignment = useCallback((idMission, userData, isAssigning = true) => {
    // Convertir en string pour les comparaisons
    const missionIdStr = idMission?.toString?.() || idMission;
    
    if (isAssigning) {
      // Mettre à jour searchMissionResult
      setSearchMissionResult((prevData) => {
        if (!Array.isArray(prevData)) return prevData;
        return prevData.map((mission) => {
          const missionRealIdStr = mission.id_mission_real?.toString?.() || mission.id_mission_real;
          const missionIdStrCompare = mission._id?.toString?.() || mission._id;
          if (missionRealIdStr === missionIdStr || missionIdStrCompare === missionIdStr) {
            return {
              ...mission,
              user: {
                user_id: userData._id,
                firstname: userData.firstname,
                lastname: userData.lastname,
                id_bestt: userData.id_bestt,
                email: userData.email,
                phone: userData.phone,
              },
            };
          }
          return mission;
        });
      });

      // Mettre à jour infoMission si c'est la mission actuelle
      setInfoMission((prevInfo) => {
        if (!prevInfo) return prevInfo;
        const prevIdStr = prevInfo._id?.toString?.() || prevInfo._id;
        if (prevIdStr !== missionIdStr) return prevInfo;
        return {
          ...prevInfo,
          user_assigned: userData._id,
          user_assigned_infos: {
            firstname: userData.firstname,
            lastname: userData.lastname,
            email: userData.email,
            phone: userData.phone,
            id_bestt: userData.id_bestt,
            tempworker: {
              _id: userData._id,
            },
          },
        };
      });
    } else {
      // Rollback : retirer l'attribution
      setSearchMissionResult((prevData) => {
        if (!Array.isArray(prevData)) return prevData;
        return prevData.map((mission) => {
          const missionRealIdStr = mission.id_mission_real?.toString?.() || mission.id_mission_real;
          const missionIdStrCompare = mission._id?.toString?.() || mission._id;
          if (missionRealIdStr === missionIdStr || missionIdStrCompare === missionIdStr) {
            return {
              ...mission,
              user: null,
              isAssigned: false,
              contract_company: [],
              contract_tempworker: [],
            };
          }
          return mission;
        });
      });

      setInfoMission((prevInfo) => {
        if (!prevInfo) return prevInfo;
        const prevIdStr = prevInfo._id?.toString?.() || prevInfo._id;
        if (prevIdStr !== missionIdStr) return prevInfo;
        return {
          ...prevInfo,
          user_assigned: null,
          user_assigned_infos: null,
          contract_company: [],
          contract_tempworker: [],
        };
      });
    }
  }, []);

  const updateMissionStatusLocal = useCallback((idMission, updates) => {
    const missionIdStr = idMission?.toString?.() || idMission;
    const clearsAssignment =
      updates?.user === null ||
      updates?.user_assigned === null ||
      updates?.isAssigned === false;

    setSearchMissionResult((prevData) => {
      if (!Array.isArray(prevData)) return prevData;
      return prevData.map((mission) => {
        const realId = mission.id_mission_real?.toString?.() || mission.id_mission_real;
        const mId = mission._id?.toString?.() || mission._id;
        if (realId === missionIdStr || mId === missionIdStr) {
          return {
            ...mission,
            ...updates,
            ...(clearsAssignment
              ? {
                  user: null,
                  isAssigned: false,
                  contract_company: [],
                  contract_tempworker: [],
                }
              : {}),
          };
        }
        return mission;
      });
    });

    setInfoMission((prev) => {
      if (!prev) return prev;
      const prevId = prev._id?.toString?.() || prev._id;
      if (prevId !== missionIdStr) return prev;
      if (clearsAssignment) {
        return {
          ...prev,
          ...updates,
          user_assigned: null,
          user_assigned_infos: null,
          contract_company: [],
          contract_tempworker: [],
        };
      }
      return { ...prev, ...updates };
    });
  }, []);

  return (
    <roadContext.Provider
      value={{
        language,
        modalShow,
        setModalShow,
        modalType,
        setModalType,
        modalData,
        setModalData,
        modalDataReturn,
        setModalDataReturn,
        slideOverShow,
        setSlideOverShow,
        slideOverType,
        setSlideOverType,
        slideOverHasUnsavedChanges,
        setSlideOverHasUnsavedChanges,
        typeNav,
        email,
        setEmail,
        name,
        setName,
        updateUser,
        auth,
        setAuth,
        refreshUser,
        setRefreshUser,
        refreshLoadUser,
        refreshWorker,
        setRefreshWorker,
        refreshLoadWorker,
        sidebarOpen,
        setSidebarOpen,
        sidebarExpanded,
        setSidebarExpanded,
        expID,
        setExpID,
        objID,
        setObjID,
        timeSheetHistoryId,
        setTimeSheetHistoryId,
        objType,
        setObjType,
        userUnAssigned,
        setUserUnAssigned,
        adminTempWorkerId,
        setAdminTempWorkerId,
        adminUserId,
        setAdminUserId,
        adminFileName,
        setAdminFileName,
        adminType,
        setAdminType,
        updateTempWorker,
        setUpdateTempWorker,
        timeData,
        setTimeData,
        refreshTime,
        setRefreshTime,
        timeCheck,
        setTimeCheck,
        content,
        setContent,
        totalH,
        setTotalH,
        coeffs,
        setCoeffs,
        infoVivier,
        setInfoVivier,
        listVivier,
        setListVivier,
        refreshVivierLog,
        setRefreshVivierLog,

        currentPageTimeSheetToBeChecked,
        setCurrentPageTimeSheetToBeChecked,
        timeSheetSearchTimeSheetToBeChecked,
        setTimeSheetSearchTimeSheetToBeChecked,
        timeSheetSearchTypeTimeSheetToBeChecked,
        setTimeSheetSearchTypeTimeSheetToBeChecked,
        dateRangeTimeSheetToBeChecked,
        setDateRangeTimeSheetToBeChecked,

        currentPageTimeSheetChecked,
        setCurrentPageTimeSheetChecked,
        timeSheetSearchTimeSheetChecked,
        setTimeSheetSearchTimeSheetChecked,
        timeSheetSearchTypeTimeSheetChecked,
        setTimeSheetSearchTypeTimeSheetChecked,
        dateRangeTimeSheetChecked,
        setDateRangeTimeSheetChecked,

        currentPageTimeSheetLitigation,
        setCurrentPageTimeSheetLitigation,
        timeSheetSearchTimeSheetLitigation,
        setTimeSheetSearchTimeSheetLitigation,
        timeSheetSearchTypeTimeSheetLitigation,
        setTimeSheetSearchTypeTimeSheetLitigation,
        dateRangeTimeSheetLitigation,
        setDateRangeTimeSheetLitigation,

        openModal,
        setOpenModal,

        missionDetails,
        setMissionDetails,
        scheduleWeeks,
        setScheduleWeeks,
        updSchedule,
        setUpdSchedule,
        activeScheduleWeekDay,
        setActiveScheduleWeekDay,
        scheduleWeeksNew,
        setScheduleWeeksNew,
        refreshMissionDetails,
        setRefreshMissionDetails,

        refreshCompanyBigAccount,
        setRefreshCompanyBigAccount,
        removeAllParameters,

        reviewUntreatedDelete,
        setReviewUntreatedDelete,
        refreshUntreated,
        setRefreshUntreated,

        refreshQualifications,
        setRefreshQualifications,
        refreshQualification,
        setRefreshQualification,

        usersVivier,
        setUsersVivier,

        userVivierToArchive,
        setUserVivierToArchive,
        userVivierToArchiveUpdated,
        setUserVivierToArchiveUpdated,

        commentID,
        setCommentID,
        commentIDUpd,
        setCommentIDUpd,

        tempWorkerToRefuse,
        setTempWorkerToRefuse,
        refuseMissionId,
        setRefuseMissionId,
        currentRefusedReason,
        setCurrentRefusedReason,
        currentRefusedReasonComment,
        setCurrentRefusedReasonComment,

        userData,
        setUserData,
        tempWorkerData,
        setTempWorkerData,

        target,
        setTarget,

        assignationMissionTempWorker,
        setAssignationMissionTempWorker,

        modifyMissionDetailData,
        setModifyMissionDetailData,

        listChangesMissionDetail,
        setListChangesMissionDetail,
        isChangesNeedsNewContractMissionDetail,
        setIsChangesNeedsNewContractMissionDetail,

        searchMissionResult,
        setSearchMissionResult,

        searchTempWorkerAssignationResult,
        setSearchTempWorkerAssignationResult,
        searchTempWorkerAssignationRefusedResult,
        setSearchTempWorkerAssignationRefusedResult,
        searchTempWorkerAssignationPendingContactResult,
        setSearchTempWorkerAssignationPendingContactResult,
        updateTempWorkerRefusedState,
        updateTempWorkerPendingContactState,
        updateMissionAssignment,
        updateMissionStatusLocal,

        searchTempWorkerInviteResult,
        setSearchTempWorkerInviteResult,

        infoMission,
        setInfoMission,

        searchTempWorkerResult,
        setSearchTempWorkerResult,
        tempWorkerCommentCountByUserId,

        updatedTimesheet,
        setUpdatedTimesheet,

        dataCreateMission,
        setDataCreateMission,

        refreshPayslips,
        setRefreshPayslips,

        missionInitialPage,
        setMissionInitialPage,

        slideOverCandidatesList,
        setSlideOverCandidatesList,
        slideOverCurrentIndex,
        setSlideOverCurrentIndex,
        slideOverMissionActions,
        setSlideOverMissionActions,
      }}
    >
      {children}
    </roadContext.Provider>
  );
}

export { ContextProvider, roadContext };
